export const numMaxItemPerSession = 50;
export const readingItemsPerSet = 10;
export const writingItemsPerSet = 2;
export const listeningItemsPerSet = 5;
export const speakingItemsPerSet = 4;
// in minutes
export const timePerSet = 5;
export const timePerItem = 0.5;
